import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Slider, Checkbox, Input, Switch, Col, Row,
} from 'antd';
import { SFCard } from '../../../../components/SF-UI';
import { changePriceOMConfigRequest } from '../redux/actions/change_priceom_config.actions';
import { getPriceOMConfigRequest } from '../redux/actions/get_priceom_config.actions';
import { get } from '../../../../shared/helpers';

const mapStateToProps = (state) => {
    const { config, config_id } = state.PlatformManagement.Price_o_matic_update;
    return { config, config_id };
};

export default connect(mapStateToProps, null)(class Configure extends Component {
    componentDidMount() {
        this.props.dispatch(getPriceOMConfigRequest());
    }

    changeSettings = (value, key) => this.props.dispatch(changePriceOMConfigRequest(this.props.config_id, { [key]: value }))

    render() {
        const { config } = this.props;
        return (
            config
            && (
                <Row>
                    <Col span={24} className="section">
                        <Switch defaultChecked={get(config, 'use_priceomatic')} onChange={value => this.changeSettings(value, 'use_priceomatic')} size="default" style={{ float: 'right', marginRight: 10, marginTop: -40 }} />
                        <SFCard className="border-shadows">
                            <h4>Adjust Matching Tolerances</h4>
                            <br />
                            <div className="form__form-group">
                                <p style={{ paddingBottom: '10px' }}>
                                    <strong>Mileage Tolerance</strong>
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'mileage_tolerance')} marks={{ 0: '0', 20000: '20000' }} min={0} max={20000} defaultValue={config.mileage_tolerance} />
                                <p style={{ paddingBottom: '10px', paddingTop: '20px' }}>
                                    <strong>Year Tolerance</strong>
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'year_tolerance')} marks={{ 0: '0', 5: '5' }} min={0} max={5} defaultValue={config.year_tolerance} />
                                <p style={{ paddingBottom: '10px', paddingTop: '20px' }}>
                                    <strong>Engine Size (CC) Tolerance</strong>
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'cc_tolerance')} marks={{ 0: '0', 50: '50' }} min={0} max={50} defaultValue={config.cc_tolerance} />
                            </div>
                        </SFCard>
                    </Col>
                    <Col span={24} className="section">
                        <SFCard className="border-shadows">
                            <h4>Adjust Pricing Rules</h4>
                            <br />
                            <br />
                            <div className="form__form-group">
                                <p>
                                    <strong style={{ paddingBottom: '10px' }}>Price Tolerance based upon mismatched year</strong>
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'year_tolerance_price')} marks={{ 0: '0', 500: '500' }} min={0} max={500} defaultValue={config.year_tolerance_price} />
                                <p style={{ marginTop: '35px' }}>
                                    <strong>Price Tolerance based upon mismatched mileage</strong>
                                </p>
                                <br />
                                <p style={{ marginBottom: '20px' }}>
                                    When price is under £1,000
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'mileage_bandings_tolerance.price_under_1000')} marks={{ 0: '0', 500: '500' }} min={0} max={500} defaultValue={config.mileage_bandings_tolerance.price_under_1000} />
                                <p style={{ marginTop: '35px', marginBottom: '20px' }}>
                                    When price is between £1,001 and £5,000
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'mileage_bandings_tolerance.price_1000_to_5000')} marks={{ 0: '0', 500: '500' }} min={0} max={500} defaultValue={config.mileage_bandings_tolerance.price_1000_to_5000} />
                                <p style={{ marginTop: '35px', marginBottom: '20px' }}>
                                    When price is between £5,001 and £10,000
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'mileage_bandings_tolerance.price_5001_to_10000')} marks={{ 0: '0', 500: '500' }} min={0} max={500} defaultValue={config.mileage_bandings_tolerance.price_5001_to_10000} />
                                <p style={{ marginTop: '35px', marginBottom: '20px' }}>
                                    When price is between £10,001 and £15,000
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'mileage_bandings_tolerance.price_10001_to_15000')} marks={{ 0: '0', 500: '500' }} min={0} max={500} defaultValue={config.mileage_bandings_tolerance.price_10001_to_15000} />
                                <p style={{ marginTop: '35px', marginBottom: '20px' }}>
                                    When price is over £15,000 (for every 1000 miles over)
                                    <br />
                                </p>
                                <Slider onAfterChange={value => this.changeSettings(value, 'mileage_bandings_tolerance.high_mileage')} marks={{ 0: '0', 500: '500' }} min={0} max={500} defaultValue={config.mileage_bandings_tolerance.high_mileage} />
                            </div>
                        </SFCard>
                    </Col>
                    <Col span={24} className="section">
                        <SFCard className="border-shadows">
                            <Row gutter={60}>
                                <Col span={12}>
                                    <h4 style={{ marginBottom: '20px' }}>Ignore Trade Adverts</h4>
                                    <Input.TextArea
                                        defaultValue={config.ignore_trade_users}
                                        onBlur={event => this.changeSettings(event.target.value, 'ignore_trade_users')}
                                        rows={4}
                                    />
                                </Col>
                                <Col span={12}>
                                    <h4 style={{ marginBottom: '20px' }}>Ignore Specific Adverts</h4>
                                    <Input.TextArea
                                        defaultValue={config.ignore_adverts}
                                        onBlur={event => this.changeSettings(event.target.value, 'ignore_adverts')}
                                        rows={4}
                                    />
                                </Col>
                            </Row>
                        </SFCard>
                    </Col>
                    <Col span={24} className="section">
                        <SFCard className="border-shadows">
                            <h4 style={{ marginBottom: '20px' }}>Price Priorities</h4>
                            {
                                Object.keys(config.priorities)
                                    .map((priority) => {
                                        if (priority === '_id') return undefined;
                                        return (
                                            <Checkbox
                                                defaultChecked={config.priorities[priority]}
                                                onChange={value => this.changeSettings(value.target.checked, `priorities.${priority}`)}
                                                key={priority}
                                            >
                                                {priority}
                                            </Checkbox>
                                        );
                                    })
                            }
                            <h4 style={{ marginTop: '30px', marginBottom: '18px' }}>Round Up Prices</h4>
                            <Checkbox onChange={event => this.changeSettings(event.target.checked, 'round_up')} defaultChecked={config.round_up} style={{ marginRight: '10px' }}>Yes</Checkbox>
                        </SFCard>
                    </Col>
                </Row>
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/components/PriceConfigure.js